import { useState, useEffect, useCallback } from 'react';

import debounce from 'lodash/debounce';
import noop from 'lodash/noop';

interface ISize {
  width: number;
  height: number;
}

/**
 * @deprecated Use RWD solution, e.g. `@media (min-height: ${SOME_BREAKPOINT}px)`
 */
export function useWindowSize(): ISize {
  const isClient = typeof window === 'object';

  const getSize = useCallback(() => {
    return {
      width: isClient ? window.innerWidth : 0,
      height: isClient ? window.innerHeight : 0,
    };
  }, [isClient]);

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return noop;
    }

    function handleResize(): void {
      setWindowSize(getSize());
    }

    const throttledHandleResize = debounce(handleResize, 200);

    window.addEventListener('resize', throttledHandleResize);

    return () => window.removeEventListener('resize', throttledHandleResize);
  }, [getSize, isClient]);

  return windowSize;
}
